import type { PreviewServer, ViteDevServer } from 'vite';

export function getViteServerUrl(
  viteServer: ViteDevServer | PreviewServer
): string {
  const origin = viteServer.config.server.origin;

  // Origin can be undefined / placeholder string so we need to check before we return it
  if (origin && URL.canParse(origin)) {
    return origin;
  }

  const viteAddress = viteServer.resolvedUrls?.local[0];

  if (!viteAddress) {
    throw new Error('Vite server listening but no URL.');
  }

  return viteAddress;
}
